<div
  class="grid grid-cols-7 gap-3 md:min-w-max"
  [id]="id() | appendTestId: 'week'"
  [attr.data-testid]="id() | appendTestId: 'week'">
  <div class="pointer-events-none flex h-12 w-12 items-center justify-center">
    {{
      textStore.texts()
        | filterTexts: ERelationType.shortSunday : EEntityType.generic
        | language
    }}
  </div>
  <div class="pointer-events-none flex h-12 w-12 items-center justify-center">
    {{
      textStore.texts()
        | filterTexts: ERelationType.shortMonday : EEntityType.generic
        | language
    }}
  </div>
  <div class="pointer-events-none flex h-12 w-12 items-center justify-center">
    {{
      textStore.texts()
        | filterTexts: ERelationType.shortTuesday : EEntityType.generic
        | language
    }}
  </div>
  <div class="pointer-events-none flex h-12 w-12 items-center justify-center">
    {{
      textStore.texts()
        | filterTexts: ERelationType.shortWednesday : EEntityType.generic
        | language
    }}
  </div>
  <div class="pointer-events-none flex h-12 w-12 items-center justify-center">
    {{
      textStore.texts()
        | filterTexts: ERelationType.shortThursday : EEntityType.generic
        | language
    }}
  </div>
  <div class="pointer-events-none flex h-12 w-12 items-center justify-center">
    {{
      textStore.texts()
        | filterTexts: ERelationType.shortFriday : EEntityType.generic
        | language
    }}
  </div>
  <div class="pointer-events-none flex h-12 w-12 items-center justify-center">
    {{
      textStore.texts()
        | filterTexts: ERelationType.shortSaturday : EEntityType.generic
        | language
    }}
  </div>
</div>
<div class="grid grid-cols-7 gap-3" [id]="id() | appendTestId: 'day-grid'">
  @for (day of previousMonthDays(); track $index) {
    <div
      [id]="id() | appendTestId: 'prev-month-day-' + $index"
      [attr.data-testid]="id() | appendTestId: 'prev-month-day-' + $index"
      class="box-border flex h-12 w-12 items-center justify-center opacity-30">
      {{ day }}
    </div>
  }
  @for (day of daysOfTheMonth(); track $index) {
    @let isActive = day | isDayOfDate: date() : shownMonth() : shownYear();
    @let isToday = day | isDayOfDate: today : shownMonth() : shownYear();
    @let IsBeforeMin = day | isDayBefore: min() : shownMonth() : shownYear();
    @let IsAfterMax = day | isDayAfter: max() : shownMonth() : shownYear();
    @let isNotInListDates =
      day
        | IsDayNotInDateList: restrictedDateList() : shownMonth() : shownYear();
    <div
      [tabindex]="IsBeforeMin || IsAfterMax || isNotInListDates ? -1 : 0"
      class="box-border h-12 w-12 cursor-pointer"
      [id]="id() | appendTestId: 'day-click-box'"
      [ngClass]="{
        'pointer-events-none cursor-not-allowed opacity-20':
          IsBeforeMin || IsAfterMax || isNotInListDates,
      }"
      [attr.data-testid]="id() | appendTestId: 'day-click-box'"
      (keydown.enter)="onDayChange.emit(day)"
      (click)="onDayChange.emit(day)">
      <div
        [id]="id() | appendTestId: 'day'"
        [attr.data-testid]="id() | appendTestId: 'day'"
        class="hover:bg-input-focus/20 flex h-full w-full items-center justify-center rounded-full"
        [ngClass]="{
          'bg-input-focus font-semibold text-white': isActive,
          'bg-input-focus/20 font-semibold': isToday && !isActive,
        }"
        (mouseenter)="highlightedDays.push(day)"
        (mouseleave)="removeFromHighlightedDays(day)"
        [ngStyle]="{
          background: isActive
            ? focusColor()
            : highlightedDays.includes(day)
              ? focusColor() + '22'
              : isToday && !isActive
                ? focusColor() + '33'
                : '',
        }">
        {{ day }}
      </div>
    </div>
  }
  @for (day of nextMonthDays(); track $index) {
    <div
      [id]="id() | appendTestId: 'next-month-day-' + $index"
      [attr.data-testid]="id() | appendTestId: 'next-month-day-' + $index"
      class="box-border flex h-12 w-12 cursor-pointer items-center justify-center opacity-30">
      {{ day }}
    </div>
  }
</div>
